import sectionMarkqueueRowsCss from '../css-snippets/section-markqueue-rows';

const html = `
<style>${sectionMarkqueueRowsCss}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#f7eee7"
  data-top-padding="true" data-bottom-padding="true"
  style="background-color: #f7eee7; color: #000000; --text-color: #000000;"
  data-text-color="#000000">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div data-attribute="container" data-enable-container="false" class="">
      <div class="wrap-card">
        <div data-attribute="title-markqueue" class="title-markqueue">
          <h3 style="text-align:center;"><span style="color:#1f1f1f;">My Girl was </span><span
              style="color:#4ce64c;">Bug-Free All Year</span><span style="color:#1f1f1f;"> and My Vet
              Can't Stop Saying How Good She Looks</span></h3>
          <p style="text-align:center;">&nbsp;</p>
        </div>
        <div data-attribute="list-rows" class="list-rows">
          <div data-attribute="row-markqueue" class="wrap-item">
             <div data-attribute="wrap-img" class="wrap-img">
              <img data-attribute="img-item" class="img-item"
                src="https://cdn.skyfastimg.com/images/2026/03/23/image-69c0fd48650ae9c1c7429167.jpg?w=50&amp;h=50&amp;q=80"
                alt="">
            </div>

            <div data-attribute="wrap-img" class="wrap-img">
              <img data-attribute="img-item" class="img-item"
                src="https://cdn.skyfastimg.com/images/2026/03/23/image-69c0fd4dd8d8a79b82b7cc2e.webp?w=50&amp;h=50&amp;q=80"
                alt="">
            </div>

            <div data-attribute="wrap-img" class="wrap-img">
              <img data-attribute="img-item" class="img-item"
                src="https://cdn.skyfastimg.com/images/2026/03/23/image-69c0fd53ab73a4a5ff119000.webp?w=50&amp;h=50&amp;q=80"
                alt="">
            </div>

            <div data-attribute="wrap-img" class="wrap-img">
              <img data-attribute="img-item" class="img-item"
                src="https://cdn.skyfastimg.com/images/2026/03/23/image-69c0fd5c778eb756be39c169.jpg?w=50&amp;h=50&amp;q=80"
                alt="">
            </div>
          </div>
          <div data-attribute="row-markqueue" class="wrap-item">
             <div data-attribute="wrap-img" class="wrap-img">
              <img data-attribute="img-item" class="img-item"
                src="https://cdn.skyfastimg.com/images/2026/03/23/image-69c0fd68cd3e2a5669703b8a.webp?w=50&amp;h=50&amp;q=80"
                alt="">
            </div>

            <div data-attribute="wrap-img" class="wrap-img">
              <img data-attribute="img-item" class="img-item"
                src="https://cdn.skyfastimg.com/images/2026/03/23/image-69c0fd6cdb8ebc1687a9fc9a.jpg?w=50&amp;h=50&amp;q=80"
                alt="">
            </div>

            <div data-attribute="wrap-img" class="wrap-img">
              <img data-attribute="img-item" class="img-item"
                src="https://cdn.skyfastimg.com/images/2026/03/23/image-69c0fd7003f9290501359067.jpg?w=50&amp;h=50&amp;q=80"
                alt="">
            </div>
          </div>
          <div data-attribute="row-markqueue" class="wrap-item">
           <div data-attribute="wrap-img" class="wrap-img">
              <img data-attribute="img-item" class="img-item"
                src="https://cdn.skyfastimg.com/images/2026/03/23/image-69c0fd793080a535baf8be33.webp?w=50&amp;h=50&amp;q=80"
                alt="">
            </div>

            <div data-attribute="wrap-img" class="wrap-img">
              <img data-attribute="img-item" class="img-item"
                src="https://cdn.skyfastimg.com/images/2026/03/23/image-69c0fd7cff88cd10a45dbbc1.jpg?w=50&amp;h=50&amp;q=80"
                alt="">
            </div>

            <div data-attribute="wrap-img" class="wrap-img">
              <img data-attribute="img-item" class="img-item"
                src="https://cdn.skyfastimg.com/images/2026/03/23/image-69c0fd80c92a3f038e7420f7.webp?w=50&amp;h=50&amp;q=80"
                alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
